import ExportIcon from '@/components/Icons/ExportIcon';
import { Button, type SxProps, type Theme } from '@mui/material';
import type { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

export interface IViewButtonProps<T extends GridValidRowModel> extends GridRenderCellParams<T> {
  onClick: (row: T) => void;
  sx?: SxProps<Theme>;
}

function ViewButton<T extends GridValidRowModel>({ sx, row, onClick }: IViewButtonProps<T>) {
  const onActionClick = useCallback(() => {
    onClick(row);
  }, [onClick, row]);

  return (
    <Button
      variant='outlined'
      color='primary'
      sx={{
        minHeight: '29px',
        width: '68px',
        padding: 0,
        borderRadius: '32px',
        textWrap: 'nowrap',
        ...sx,
      }}
      onClick={onActionClick}
    >
      <ExportIcon className='w-[12px] mr-[4px]' />
      <span>View</span>
    </Button>
  );
}

export default ViewButton;
